import React from "react";
import { Col } from "@amzn/stencil-react-components/layout";
import { Text } from "../typography";
import { Link } from "@amzn/stencil-react-components/link";

interface SdaChangeProps {
  onSupportLinkClick: () => void;
}

export const SdaChange = ({ onSupportLinkClick }: SdaChangeProps) => {
  const supportLink = (
    <Link
      target="_blank"
      href="https://amazon.com/applicationhelp"
      onClick={onSupportLinkClick}
    >
      here
    </Link>
  );

  return (
    <Col gridGap="1rem">
      <Text>
        Please click {supportLink} to contact candidate support for questions or
        changes to your first day on site.
      </Text>
    </Col>
  );
};
